import Route from '@ember/routing/route';

export default class SettingsBillingRoute extends Route {}
